import React, { useState } from "react";
import Switcher from "./Components/Switcher/Switcher";
import { BlogCardData } from "./InsightsData";
import BlogCard from "./Components/BlogCard/BlogCard";

const options = [
  "All",
  "Compliance",
  "BCM",
  "Fraud",
  "GRC",
  "Outsourcing Risk",
];
const BlogPage = () => {
  const [activeOption, setActiveOption] = useState("All");
  
  const combinedData = activeOption === "All"
  ? [
      ...BlogCardData["All"],
      ...BlogCardData["Compliance"],
      ...BlogCardData["BCM"],
      ...BlogCardData["Fraud"],
      ...BlogCardData["GRC"],
      ...BlogCardData["Outsourcing Risk"]
    ]
    //@ts-ignore
  : BlogCardData[activeOption];

  return (
    <div>
      <Switcher
        options={options}
        current={activeOption}
        onChange={setActiveOption}
      />
      <div className="blogCardCnt">
        {/* @ts-ignore */}
        {combinedData?.map(({ heading, navTo, description }) => (
          <BlogCard heading={heading} navTo={navTo} description={description} />
        ))}
      </div>
    </div>
  );
};

export default BlogPage;
